import { render, staticRenderFns } from "./EstablishmentReviewContent.vue?vue&type=template&id=9c074fc0&"
import script from "./EstablishmentReviewContent.vue?vue&type=script&lang=js&"
export * from "./EstablishmentReviewContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "EstablishmentReviewContent.vue"
export default component.exports